import { Dispatch, SetStateAction } from 'react';

import { Typography } from '@mui/material';

import SmallDialog from '@/components/SmallDialog';

import PostGenerationBody from './PostGenerationBody';
import PreGenerationBody from './PreGenerationBody';
import useGenerationBody from './useGenerationBody';

const KeyDialog = ({
  open,
  setOpen
}: {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const { generated, handleClose } = useGenerationBody();
  return (
    <SmallDialog
      handleClose={() => {
        handleClose(setOpen);
      }}
      open={open}
    >
      <Typography
        sx={{ width: 590, p: 3, pb: 0 }}
        variant='subtitle2'
      >
        Generate new API token
      </Typography>
      {generated ? (
        <PostGenerationBody
          handleClose={() => {
            handleClose(setOpen);
          }}
        />
      ) : (
        <PreGenerationBody
          handleClose={() => {
            handleClose(setOpen);
          }}
        />
      )}
    </SmallDialog>
  );
};
export default KeyDialog;
